import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  styled,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button,
} from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import {
  getCampaignThunk,
  getTrackierThunk,
  updateCampaignStatusThunk,
} from "../../../redux/thunks/campaign.thunk";
import { CampaignStatus } from "../../../enum/campaign";
import { Role } from "../../../enum/auth";

interface IProps extends IWithClassName {
  campaign: string;
  openTrackierModal: (value: boolean, campaignId: string) => void;
}

const MenuAction = ({ className, campaign, openTrackierModal }: IProps) => {
  const { role } = useAppSelector((state) => state.auth);
  // const { trackier } = useAppSelector((state) => state.campaign);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // useEffect(() => {
  //   setAnchorEl(null);
  //   openTrackierModal(!!trackier.list.data, campaign);
  // }, [trackier.list.data]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  const handleAction = (campaign: string, step: number) => {
    navigate(`/campaign/${campaign}/${step}`);
    handleClose();
  };

  const handleDeactivate = () => {
    setOpenDialog(true);
    handleClose();
  };

  const deactivateCampaign = async (campaign: string) => {
    setOpenDialog(false);
    await dispatch(
      updateCampaignStatusThunk(campaign, CampaignStatus.Inactive),
    );
    dispatch(getCampaignThunk());
  };

  const addTrackierHandler = (campaignId: string) => {
    dispatch(getTrackierThunk(campaignId));
    setAnchorEl(null);
    openTrackierModal(true, campaignId);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreHoriz className="icon-menu" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={className}
      >
        <MenuItem onClick={() => handleAction(campaign, 3)}>Summary</MenuItem>
        <MenuItem onClick={() => handleAction(campaign, 0)}>
          Update Bid
        </MenuItem>
        <MenuItem onClick={() => handleAction(campaign, 0)}>
          Update Budget
        </MenuItem>
        <MenuItem onClick={() => handleAction(campaign, 2)}>
          Update Creatives
        </MenuItem>
        <MenuItem onClick={handleDeactivate}>Deactivate</MenuItem>
        {role && role === Role.ADMIN && <MenuItem onClick={() => addTrackierHandler(campaign)}>Add Trackier</MenuItem>}
      </Menu>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Are you sure want to deactivate the Campaign?</DialogTitle>
        <DialogContent>
          Note: Your campaign would be deactivated in 24 hours. Click confirm to
          deactivate campaign.
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setOpenDialog(false)}
          >
            No
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => deactivateCampaign(campaign)}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default styled(MenuAction)(({ theme }: IWithThemeProps) => ({
  ".MuiMenu-paper": {
    backgroundColor: theme?.palette.background.default,
    color: theme?.palette.text.primary,
  },
  ".MuiMenuItem-root": {
    backgroundColor: theme?.palette.otherFeatures.border,
    margin: 5,
    borderRadius: 5,
  },
}));
